
import React from 'react';

export const DefaultBuildingImage = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center ${className}`}>
      <svg 
        width="120" 
        height="120" 
        viewBox="0 0 120 120" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="text-blue-400"
      >
        <rect x="20" y="40" width="80" height="60" fill="currentColor" opacity="0.3"/>
        <rect x="30" y="50" width="60" height="50" stroke="currentColor" strokeWidth="2" fill="none"/>
        <rect x="35" y="55" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="47" y="55" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="59" y="55" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="71" y="55" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="35" y="67" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="47" y="67" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="59" y="67" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="71" y="67" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="35" y="79" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="47" y="79" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="59" y="79" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="71" y="79" width="8" height="8" fill="currentColor" opacity="0.6"/>
        <rect x="50" y="85" width="12" height="15" fill="currentColor" opacity="0.8"/>
      </svg>
    </div>
  );
};
